export class Policy {
    automaticAdjustmentKey: string;
    coverages: Array<any>;
    effectiveDate: Date | string;
    expirationDate: Date | string;
    policyNumber: string;
    affinityGroupId: string;
    affinityGroupName: string;
    premiumDiscountKey: string;
    premiumDiscountName: string;
    term: number;
    totalCost: number;
    totalPremium: number;

    constructor() {
        this.automaticAdjustmentKey = null;
        this.coverages = null;
        this.effectiveDate = null;
        this.expirationDate = null;
        this.policyNumber = null;
        this.premiumDiscountKey = null;
        this.premiumDiscountName = null;
        this.term = null;
        this.totalCost = 0;
        this.affinityGroupId = null;
        this.affinityGroupName = null;
        this.totalPremium = 0;
    }
}
